import { QuestionCircleOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Popover } from 'antd';
import { PropsWithChildren, ReactNode } from 'react';
import { useTranslate } from '@tolgee/react';

const RightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
const DataUpdateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
`;
interface DataUpdateProps {
  content?: ReactNode;
}

function DataUpdate(props: PropsWithChildren<DataUpdateProps>) {
  const { content, children } = props;
  const { t } = useTranslate();

  return (
    <RightContainer>
      {content ? (
        <Popover
          placement="topLeft"
          getPopupContainer={(node: any) => document.body}
          content={content}
        >
          <DataUpdateContainer>
            <div>{t('ViewDashboard.nav.数据更新')}</div>
            <QuestionCircleOutlined />
          </DataUpdateContainer>
        </Popover>
      ) : null}
      {children}
    </RightContainer>
  );
}
export default DataUpdate;
